import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { getLocalSEOAgentReport, runLocalSEOAgentReport } from "src/common/Scraper"
import { LocalSEOAgentReport, LocalSEOAgentRunPayload } from "../types"
import useUpdateUserAgents from "../../hooks/useUpdateUserAgents";
import { sleep } from "src/common/config/FunctionHelper";
import { useState } from "react";

export const useGetLocalSEOReport = ({ userId, siteId, accountId, locationId }: { userId: string, siteId: string, accountId: string, locationId: string }) => {
  const isParamsValid =
    !!userId &&
    userId !== 'undefined' &&
    userId !== 'null' &&
    !!accountId &&
    accountId !== 'undefined' &&
    accountId !== 'null' &&
    accountId !== '' &&
    !!locationId &&
    locationId !== 'undefined' &&
    locationId !== 'null' &&
    locationId !== '';


  return useQuery<LocalSEOAgentReport>({
    queryKey: ["getLocalSEOReport", accountId, locationId],
    queryFn: isParamsValid
      ? () => {
        return getLocalSEOAgentReport(userId, siteId, accountId, locationId);
      }
      : () => Promise.resolve({} as LocalSEOAgentReport),
    enabled: isParamsValid,
  })
}

interface UseRunLocalSEOAgent {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
  onMutateStart?: () => void;
}

interface HandleLocalSEORunProps {
  account_id: string;
  location_id: string;
  local_keywords: string[];
}

export const useRunLocalSEOAgent = ({ onSuccess, onError, onMutateStart }: UseRunLocalSEOAgent = {}) => {
  const queryClient = useQueryClient()
  const { mutate: updateAgents } = useUpdateUserAgents('local-seo');

  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const localSEORunMutation = useMutation({
    mutationFn: (payload: LocalSEOAgentRunPayload) => runLocalSEOAgentReport(payload),
    mutationKey: ["runLocalSEOAgent"],
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ["getLocalSEOReport"]
      })
      if (onSuccess) {
        onSuccess(data);
      }
    },
    onError: (error, variables) => {
      if (onError) {
        onError(error);
      }
      updateLocalSEOAgentStatus(false, variables.account_id, variables.location_id, variables.site_id)
    }
  })


  function updateLocalSEOAgentStatus(status: boolean, account_id: string, location_id: string, overrideSiteId?: string) {
    updateAgents({
      site_id: overrideSiteId,
      agents: [
        {
          name: 'local_seo',
          enabled: status,
          config: {
            account_id,
            location_id,
            local_keywords: ['']
          }
        }
      ]
    });
  }


  async function handleLocalSEORun({ account_id, location_id, local_keywords }: HandleLocalSEORunProps, overrides: { siteId: string; userId: string, shouldRun?: boolean }) {
    const effectiveUserId = overrides?.userId;
    const effectiveSiteId = overrides?.siteId;
    const shouldRun = overrides?.shouldRun ?? true;

    if (onMutateStart) {
      onMutateStart();
    }

    setTimeout(() => {
      setDialogOpen(false);
    }, 2000);

    if(shouldRun){
      localSEORunMutation.mutate({
        user_id: effectiveUserId || '',
        site_id: effectiveSiteId || '',
        account_id,
        location_id,
        local_keywords
      })
    }

    await sleep(2000);

    updateLocalSEOAgentStatus(true, account_id, location_id, overrides?.siteId)

  }


  return {
    updateLocalSEOAgentStatus,
    handleLocalSEORun,
    localSEORunMutation,
    setDialogOpen,
    dialogOpen
  }
}

